import React from 'react';
import DispositionControls from "./Sidebar/DispositionControls";
import SidebarTextSettings from "./Sidebar/SidebarTextSettings";
import SidebarDrawSettings from "./Sidebar/SidebarDrawSettings";
import SidebarImageSettings from "./Sidebar/SidebarImageSettings";
import SidebarShapeSettings from "./Sidebar/SidebarShapeSettings";

const CanvaSidebar = ({
    sidebarVisible,
    selectedObject,
    setSidebarVisible,
    resetToSelection,
    sendToBack,
    bringToFront,
    moveBackward,
    moveForward,
    drawingMode,
    deleteSelectedObject,
    drawingSettings,
    setDrawingSettings,
    textSettings,
    setTextSettings,
    imageSettings,
    setImageSettings,
    shapeSettings,
    setShapeSettings,
    changeSelectedShapeType,
    copyObject,
    pasteObject,
}) => {
    const setSidebarVisibility = (nextVisibility) => {
        if (nextVisibility === false) resetToSelection?.();
        setSidebarVisible(nextVisibility);
    };

    const renderSelectedObjectSettings = () => {
        if (!selectedObject) return null;

        switch (selectedObject.type) {
            case "textbox":
                return <SidebarTextSettings setSidebarVisible={setSidebarVisibility} textSettings={textSettings} setTextSettings={setTextSettings}/>;
            case "triangle":
            case "circle":
            case "rect":
            case "polygon":
            case "line":
                return <SidebarShapeSettings setSidebarVisible={setSidebarVisibility} shapeSettings={shapeSettings} setShapeSettings={setShapeSettings} changeSelectedShapeType={changeSelectedShapeType}/>;
            case "image":
                return <SidebarImageSettings setSidebarVisible={setSidebarVisibility} imageSettings={imageSettings} setImageSettings={setImageSettings}/>;
            default:
                if (selectedObject.customType === "arrow") {
                    return <SidebarShapeSettings setSidebarVisible={setSidebarVisibility} shapeSettings={shapeSettings} setShapeSettings={setShapeSettings} changeSelectedShapeType={changeSelectedShapeType}/>;
                }
                return null;
        }
    };

    // Les outils de création et de réglage du tableau sont désormais dans la
    // barre compacte. Le panneau latéral ne s’ouvre que pour éditer un objet
    // sélectionné ou régler le pinceau pendant le dessin.
    if (!selectedObject && !drawingMode) return null;

    return <div className={`barre_laterale ${sidebarVisible ? "visible" : ""}`}>
        {selectedObject ? <>
            {!Array.isArray(selectedObject) && renderSelectedObjectSettings()}
            <DispositionControls moveBackward={moveBackward} bringToFront={bringToFront}
                                 moveForward={moveForward} sendToBack={sendToBack}
                                 deleteSelectedObject={deleteSelectedObject} copyObject={copyObject}
                                 pasteObject={pasteObject}/>
        </> : <>
            <SidebarDrawSettings setSidebarVisible={setSidebarVisibility} drawingSettings={drawingSettings}
                                 setDrawingSettings={setDrawingSettings}/>
            <DispositionControls moveBackward={moveBackward} bringToFront={bringToFront}
                                 moveForward={moveForward} sendToBack={sendToBack}
                                 deleteSelectedObject={deleteSelectedObject} copyObject={copyObject}
                                 pasteObject={pasteObject}/>
        </>}
    </div>;
};

export default CanvaSidebar;
